export default function popupEvent() {
  $('.popup-close').on('click', () => {
    $('.popup-overlay').remove();
  });

  $('.js-checkout').on('click', () => {
    $('.popup-overlay').remove();
    $('#checkout').modal();
  });
}
